import React from 'react';
import { Alert } from '@mui/material';
import OutputVersionSelect from '../../Form/OutputVersionSelect';
import { WidgetProps } from '@rjsf/utils';

const OutputVersionSelectWidget = (props: WidgetProps) => {
  const { onChange, required, value, label, id, formContext } = props;
  if (!formContext.programId) return <Alert severity="error">No programId found in formContext</Alert>;
  return (
    <OutputVersionSelect
      value={value}
      label={label}
      titleId={formContext.programId ? formContext.programId : undefined}
      onChange={(e) => onChange(e.target.value)}
      required={required}
      id={id}
      squashed
    />
  );
};

export default OutputVersionSelectWidget;
